import type {PerkUsagePreviewComponentProps} from '@cohort/merchants/apps';
import {Fragment} from 'react';

export const CohortLinkPerkIntegrationsUsagePreviewComponent: React.FC<
  PerkUsagePreviewComponentProps
> = () => <Fragment />;
